<template>
    <transition name="fade">
        <div id="editor_trace" v-if="showEditor" @click.self="maskClickEvn">
            <div class="editor_trace">
                <div class="editor_trace1">
                    <div class="flex">
                        <span class="t-m-r-20">正文修正</span>
                        <textLoading v-if="streamStatus"></textLoading>
                    </div>
                    <img class="cursor_1" src="../assets/image/icon_close.png" alt="" @click="closePopup">
                </div>
                <main class="correct-main">
                    <div class="correct-left" v-if="chapter > 1">
                        <p class="correct-title"><span class="u-line-1" :title="prevTitle"
                                style="display: block;flex: 1;">{{ prevTitle }}</span><span
                                style="color: red;">(上一章正文)</span></p>
                        <div v-html="prevContent" class="yw-content"></div>
                    </div>
                    <div class="correct-left">
                        <p class="correct-title"><span class="u-line-1" :title="title"
                                style="display: block;flex: 1;">{{ title }}</span><span
                                style="color: red;">(当前正文)</span></p>
                        <div v-html="content" class="yw-content"></div>
                    </div>
                    <div class="correct-right">
                        <el-tabs v-model="activeName" :before-leave="beforeLeaveClick">
                            <el-tab-pane label="正文检测" name="1">
                                <div class="t-p-l-15 t-p-r-15">
                                    <p class="correct-form_zwjc">正文检测</p>
                                    <div class="editor_trace3_2">
                                        <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8 }"
                                            :placeholder="placeholder" v-model="currectText">
                                        </el-input>
                                    </div>
                                    <div class="editor_trace3_3">
                                        <div class="editor_trace3_4 cursor_1" @click="jcClick">开始检测</div>
                                    </div>
                                </div>
                            </el-tab-pane>

                            <el-tab-pane label="优化方案" name="2">
                                <p class="correct-form_zwjc yw-title">优化方案</p>
                                <div class="yhzw">
                                    <div v-html="currectAnswerText" ref="yw_content" class="yw-content"></div>
                                    <!-- 停止生成按钮 -->
                                    <AIStopCreate emit :hide="streamStatus" bottom="40px" @stop="clearTimer">
                                    </AIStopCreate>
                                </div>
                                <div class="t-p-l-15 t-p-r-15">
                                    <p class="correct-form_zwjc">要求<span>(非必填)</span></p>
                                    <div class="editor_trace3_2">
                                        <el-input type="textarea" :maxlength="5000" show-word-limit
                                            :autosize="{ minRows: 4, maxRows: 4 }" placeholder="修正要求"
                                            v-model="requirement">
                                        </el-input>
                                        <!-- <div class="delimg">
                                        <img src="../assets/image/icon_del.png" class="cursor_1" alt=""
                                            @click="clearText()">
                                    </div> -->
                                    </div>
                                </div>
                                <div class="editor_trace3_3 t-p-b-15">
                                    <div class="editor_trace3_4 cursor_1" @click="xzClick">AI一键修正</div>
                                </div>
                            </el-tab-pane>

                            <el-tab-pane label="修正内容" name="3">
                                <p class="correct-form_zwjc yw-title">修正内容</p>

                                <div class="yhzw" ref="editorCorrect">
                                    <div class="yhzw-content">
                                        <!-- <el-input type="textarea" ref="editorCorrect"  v-model="currectContent"></el-input> -->
                                        <markdown-renderer :content="currectContent" ref="markdownRenderer" />
                                        <!-- <div v-else v-html="currectLookContent"></div> -->
                                        <!-- 停止生成按钮 -->
                                    </div>
                                    <AIStopCreate emit :hide="streamStatus" bottom="0" @stop="clearTimer">
                                    </AIStopCreate>
                                </div>
                                <div class="editor_trace3_3 t-m-b-15">
                                    <div class="editor_trace3_4 cursor_1" @click="replace">替换原文</div>
                                </div>
                            </el-tab-pane>

                        </el-tabs>
                    </div>
                </main>
            </div>
        </div>
    </transition>
</template>
<script>
import { EventBus } from '@/utils/eventBus'
import editBox from '@/components/edit_box.vue' // 文本编辑框
import textLoading from '@/components/text_loading.vue';
import MarkdownRenderer from '@/components/global/MarkdownRenderer.vue'
import api from '@/api/api';
import lNApi from '@/api/longNovel';
import { marked } from 'marked'
export default {
    components: {
        editBox, textLoading, MarkdownRenderer
    },
    props: {
        maskClick: {
            type: Boolean,
            default: true
        },
        length: {
            type: String,
            default: '短'
        }
    },
    data() {
        return {
            showEditor: false,
            activeName: '1',
            currectText: `1.检查本章正文与上一章正文是否存在内容重复。\n2.确认本章正文开头与上一章结尾的情节、逻辑是否自然衔接，过渡是否流畅。\n3.排查本章正文内是否存在剧情、语句或情节的重复表述。\n4.审视本章是否存在剧情混乱、逻辑断层或矛盾等影响阅读体验的情况。`, //正文检测的提示词
            currectAnswerContent: '',//正文检测，只是用来替换内容
            currectAnswerText: '',//正文检测回答内容，ai
            content: '', //原正文内容
            requirement: '所有优化后的句子或段落采用加粗格式标注，便于快速定位修改点，确保校对成果清晰可查。',//要求
            currectLookContent: '',//只读，正文检测结果,ai
            currectContent: '',//可编辑，正文检测结果,ai
            placeholder: '请输入正文检测',
            streamIndex: 0, // 流式请求下标
            debounceTimer: null, // 防抖定时器
            typingTimer: null, // 打字效果定时器
            streamStatus: false, // 流式请求 false请求结束 true请求
            // streamLast: false, //流式最后一条
            novelId: '',//小说id
            chapter: '',//章节
            prevContent: '',//上一章的正文
            prevTitle: '',//上一章的标题
            title: '',//当前原文标题
            isStop: false,
        }
    },
    beforeDestroy() {
        this.clearTimer()
    },
    methods: {
        //销毁定时器
        clearTimer(status) {
            console.log('进来了销毁定时器')
            if (status) {
                this.isStop = true
            }
            clearTimeout(this.debounceTimer)
            clearInterval(this.typingTimer)
            this.streamIndex = 0
            this.streamStatus = false
        },
        getStreamContent(id) {
            // 清除之前的定时器
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer)
            }
            this.debounceTimer = setTimeout(() => {
                api.getStreamContent(id, this.streamIndex).then((res) => {
                    if (res.code === 200) {
                        if (res.data && res.data.length !== 0) {
                            this.streamIndex = this.streamIndex + res.data.length
                            let combinedText = ''
                            res.data.map((item) => {
                                if (item !== '[DONE]') {
                                    combinedText += item
                                }
                            })
                            this.typeText(combinedText, () => {
                                if (res.data[res.data.length - 1] === '[DONE]') {
                                    this.streamIndex = 0
                                    this.streamStatus = false;
                                    // sessionStorage.removeItem('streamStatus');
                                    //刷新用户信息-基础会员字符刷新
                                    this.getUserInfo()
                                    this.$message.success('AI生成完成！');
                                    return
                                }
                                this.getStreamContent(id);
                            })
                        } else {
                            this.getStreamContent(id)
                        }
                    } else {
                        this.$message.warning(res.msg)
                        this.clearTimer()
                    }
                })
            }, 500)
        },
        // 打字效果
        typeText(text, callback) {
            let index = 0
            if (this.typingTimer) {
                clearInterval(this.typingTimer)
            }
            this.typingTimer = setInterval(() => {
                if (index < text.length) {
                    if (this.activeName === '2') {
                        this.currectAnswerText += text[index].replace(/\n/g, '<br>')
                        this.currectAnswerText = this.currectAnswerText.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
                    } else if (this.activeName === '3') {
                        // this.currectLookContent += text[index].replace(/\n/g, '<br>')
                        // this.currectContent = this.currectLookContent.replace(/<br\s*\/?>/g, '\n').replace(/\*\*(.*?)\*\*/g, "$1")
                        this.currectContent += text[index]
                        // this.currectContent = this.currectContent.replace(/(?:###|####) .+?(\n\n|$)/g, '')  // 去除标题
                        //     .replace(/\n{3,}/g, '\n\n');
                    }
                    index++
                    this.$nextTick(() => {
                        let container = null
                        if (this.activeName === '2') {
                            container = this.$refs.yw_content
                        } else if (this.activeName === '3') {
                            // container = this.$refs.editorCorrect.$el.querySelector('textarea')
                            container = this.$refs.editorCorrect
                        }
                        // console.log('this.activeName=', container)
                        if (container) {
                            container.scrollTop = container.scrollHeight; // 直接滚动到底部
                        }
                    });
                } else {
                    clearInterval(this.typingTimer)
                    if (callback) {
                        callback()
                    }
                }
            }, 20)
        },
        // 打开
        open(item) {
            this.showEditor = true
            this.activeName = '1'
            this.content = item.content
            this.novelId = item.novelId
            this.chapter = item.chapter
            this.prevContent = item.prevContent
            this.prevTitle = item.prevTitle
            this.title = item.title
            this.getjczwText()
        },
        getjczwText(){
            api.getParameter('zwjc', 'requirement').then((res) => {
                if (res.code == 200) {
                   this.currectText = res.data && res.data.length > 0 && res.data[0].placeholder
                }
            })
        },
        //蒙层点击事件
        maskClickEvn() {
            if (this.maskClick) return
            this.closePopup();
        },
        // 关闭
        closePopup() {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            this.activeName = '1'
            this.content = ''
            this.currectAnswerText = ''
            this.currectContent = ''
            this.currectLookContent = ''
            this.novelId = ''
            this.chapter = ''
            this.prevContent = ''
            this.prevTitle = ''
            this.title = ''
            this.showEditor = false
        },
        //tabs切换之前的事件
        beforeLeaveClick(activeName, oldActiveName) {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return false
            }
            return true
        },
        //正文检测事件
        jcClick() {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            this.currectAnswerText = ''
            this.activeName = '2'
            let params = {
                novelId: this.novelId,
                chapter: this.chapter,
                requirement: this.currectText,
                textContent: this.content
            }
            try {
                if (this.length === '短') {
                    this.AIWrite({
                        length: '短',
                        haveId: true,
                        type: 'zwjc',
                        params: params,
                        success:(res)=>  {
                            this.streamIndex = 0
                            this.streamStatus = true
                            localStorage.setItem('AICreateId', res.data)
                            this.getStreamContent(res.data)
                        }
                    })
                    // api.novelHelpWriteId('zwjc', params).then(res => {
                    //     if (res.code === 200) {
                    //         this.streamStatus = true
                    //         localStorage.setItem('AICreateId', res.data)
                    //         this.getStreamContent(res.data)
                    //     } else {
                    //         this.$message.warning(res.msg)
                    //     }
                    // })
                } else {
                    this.AIWrite({
                        length: '长',
                        haveId: true,
                        type: 'zwjc',
                        params: { ...params, id: params.novelId },
                        success:(res)=>  {
                            this.streamIndex = 0
                            this.streamStatus = true
                            localStorage.setItem('AICreateId', res.data)
                            this.getStreamContent(res.data)
                        }
                    })
                    // lNApi.longNovelHelpWriteId('zwjc', { ...params, id: params.novelId }).then(res => {
                    //     if (res.code === 200) {
                    //         this.streamStatus = true
                    //         localStorage.setItem('AICreateId', res.data)
                    //         this.getStreamContent(res.data)
                    //     } else {
                    //         this.$message.warning(res.msg)
                    //     }
                    // })
                }

            } catch (err) {
            }

        },
        //修正事件
        xzClick() {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            if (!this.currectText.trim()) {
                this.activeName = '1'
                return
            }
            if (!this.currectAnswerText.trim()) {
                this.activeName = '1'
                return
            }
            this.currectLookContent = ''
            this.currectContent = ''
            this.activeName = '3'
            let params = {
                requirement: this.requirement,
                checkResult: this.stripHtmlTags(this.currectAnswerText),
                textContent: this.content
            }
            this.AIWrite({
                length: '中',
                haveId: false,
                type: 'zwxz',
                params: params,
                success:(res)=>  {
                    this.streamIndex = 0
                    this.streamStatus = true
                    localStorage.setItem('AICreateId', res.data)
                    this.getStreamContent(res.data)
                }
            })
            // api.novelHelpWrite('zwxz', params).then(res => {
            //     if (res.code === 200) {
            //         this.streamStatus = true
            //         localStorage.setItem('AICreateId', res.data)
            //         this.getStreamContent(res.data)
            //     } else {
            //         this.$message.warning(res.msg)
            //     }
            // })
        },
        getHtmlContent(e) {
            this.sumbitHtmlContent = e
        },
        // 替换原文
        replace() {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            if (!this.currectAnswerText.trim()) {
                // this.$message.warning('请先开始检验')
                this.activeName = '1'
                return
            }
            const html = this.$refs.markdownRenderer.$el.innerHTML;
            // console.log(html)
            EventBus.$emit('replace', {
                text: this.content,
                content: html,
                all: true
            })
            this.closePopup()
        },
    }
}
</script>

<style lang="scss" scoped>
p {
    padding: 0;
    margin: 0;
}

#editor_trace {
    width: 100vw;
    height: 100vh;
    background: rgba(14, 14, 14, 0.2);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.editor_trace {
    height: 80% !important;
    width: 80%;
    background: #FFFFFF;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.editor_trace1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    font-size: 18px;
    color: #111111;
    height: 65px;
    padding: 0 30px;
    flex-shrink: 0;
    border-bottom: 1px solid #E6EBF0;

    img {
        width: 21px;
        height: 21px;
        cursor: pointer;
    }
}

.correct-main {
    flex: 1;
    width: 100%;
    display: flex;
    margin-top: 0 !important;
    overflow: auto;

    .correct-left {
        width: 30%;
        height: 100%;
        flex-shrink: 0;
        position: relative;
        display: flex;
        flex-direction: column;

        &::after {
            content: '';
            position: absolute;
            right: 0;
            top: 0;
            height: 100%;
            border-right: 1px solid #E6EBF0;
        }

        .correct-title {
            flex-shrink: 0;
            height: 40px;
            flex-wrap: nowrap;
            display: flex;
            align-items: center;
            text-align: left;
            position: relative;
            padding: 0 15px;
            font-size: 16px;
            box-sizing: border-box;
            border-bottom: 1px solid #E6EBF0;
            cursor: default;
        }

    }

    .correct-right {
        flex: 1;
        display: flex;
        flex-direction: column;

        ::v-deep(.el-steps--simple) {
            // padding: 0;
            margin: 15px;
            height: 40px;
        }

        .correct-form {
            padding: 0 15px 15px;
        }

        ::v-deep(.el-tabs__nav-wrap) {
            &::after {
                height: 1px;
            }
        }

        .correct-form_zwjc {
            font-size: 16px;
            margin-bottom: 15px;
            margin-top: 15px;

            span {
                color: red;
            }
        }

        .editor_trace3_2 {
            margin: 0;
            width: 100%;
            height: auto;
            position: relative;

            ::v-deep(.el-textarea__inner) {
                @include scrollbar();

                &:hover {
                    @include scrollbar_hover();
                }
            }
        }

        .delimg {
            position: absolute;
            bottom: 10px;
            left: 10px;

        }

        .editor_trace3_3 {
            border: 0;
        }

        ::v-deep(.el-tabs) {
            flex: 1;
            display: flex;
            flex-direction: column;
            height: 100%;

            .el-tabs__header {
                margin: 0;
                padding: 0 15px;
            }

            .el-tabs__content {
                flex: 1;
                display: flex;
                flex-direction: column;
                overflow: auto;
                @include scrollbar($sw:none);
                &:hover {
                    @include scrollbar_hover();
                }
            }

            .el-tab-pane {
                flex: 1;
                height: 100%;
                display: flex;
                flex-direction: column;
            }
        }
    }

    .yhzw {
        margin: 0 15px;
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: auto;
        min-height: 200px;
        @include scrollbar();

        &:hover {
            @include scrollbar_hover();
        }

        ::v-deep(.stop) {
            position: sticky;
        }
    }

    .yw-title {
        padding: 0 15px !important;
    }

    .yw-content {
        flex: 1;
        padding: 15px;
        font-size: 16px;
        line-height: 1.8;
        overflow: auto;
        background-color: #FAFAFA;
        white-space: pre-wrap;
        @include scrollbar();

        &:hover {
            @include scrollbar_hover();
        }
    }

    .yhzw-content {
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;

        ::v-deep(.el-textarea) {
            flex: 1;
            background-color: #FAFAFA;
        }

        ::v-deep(.el-textarea__inner) {
            // padding: 15px;
            height: 100%;
            border: 0;
            background-color: transparent;
            @include scrollbar();

            &:hover {
                @include scrollbar_hover();
            }
        }
    }

    ::v-deep(.el-input__count) {
        background-color: transparent;
    }
}
</style>